<template>
  <div class="mb-5">
    <v-tabs :value="selectedTab"
            class="rounded-lg white--text"
            background-color="lightSecondary"
            active-class="primary"
            color="#FF8700">
      <v-tab @click="changeRoute(tab)" v-for="tab in tabs" class="white--text mr-2">{{tab.title}}</v-tab>
    </v-tabs>
  </div>
</template>

<script>
import {toString} from "lodash";

export default {
  name: "UserTabs",
  data() {
    return {
    };
  },
  props: {
    type: {
      default: 'receive'
    },
  },
  computed: {
    selectedTab(){
      if(this.$route.name == 'Users') {
        return 0
      }
      if(this.$route.name == 'UsersList') {
        return 1
      }
    },
    tabs() {
      return [
        {title: 'کاربران', key: '/panel/users'},
        {title: 'لیست کاربران', key: '/panel/users/list'},
      ]
    },
  },
  methods: {
    changeRoute(tab){
      this.$router.push(tab.key)
    }
  }

};
</script>

<style scoped lang="scss">
</style>

